module.exports = __webpack_public_path__ + "media/images/webpage/hotels/895/miki-ee0b7cdbd9ab15899db639195fe2d927.webp";